export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-09.c87d7472.svg";